import { Injectable, OnDestroy, SecurityContext } from '@angular/core';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';
import { fromEvent, Subject } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { WindowService } from '../window/window.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GenesysUrlReplaceService } from 'shared/services/genesys-url-replace/genesys-url-replace.service';

@Injectable({
  providedIn: 'root'
})
export class GenesysSmartAdvisorMessageService implements OnDestroy {
  private readonly onDestroySubject = new Subject<void>();
  private readonly windowMessages$ = fromEvent(this._window.getWindow(), 'message').pipe(
    mergeMap((evt: MessageEvent) =>
      this.genesysCloudConfigService.apiConfig$.pipe(map((apiConfig) => ({ apiConfig, evt })))
    ),
    filter((data) => data.evt.origin === data.apiConfig.apiEndpoints.purecloudUri.replace(/\/$/, '')),
    map((data) => data.evt)
  );

  static readonly SmartAdvisorEventName = 'genesys.smart-advisor.copy-paste';

  readonly copyPasteEvent$ = this.windowMessages$.pipe(
    filter((event) => event.data.eventName === GenesysSmartAdvisorMessageService.SmartAdvisorEventName),
    map((event) => {
      const eventData = event.data.eventData;
      const content = eventData.replace(/\n/ig, '<br>');
      const parsedEventData = GenesysUrlReplaceService.replaceIFrameWithUrl(content);

      return this.sanitizer.sanitize(SecurityContext.HTML, parsedEventData);
    }, takeUntil(this.onDestroySubject))
  );

  constructor(
    private readonly _window: WindowService,
    private readonly genesysCloudConfigService: GenesysCloudConfigService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnDestroy(): void {
    this.onDestroySubject.next();
    this.onDestroySubject.complete();
  }
}
